<template>
  <section class="doctor-item">
    <div
      class="d-flex align-items-center justify-content-between p-3"
      @click="$router.push(routerLink)">
      <div class="doctor-item__avatar">
        <img
          :src="avatar"
          alt=""
          width="144"
          height="144"
          class="img-fluid rounded-circle">
      </div>
      <div class="px-3 doctor-item__content">
        <h3 class="my-0">{{ data.name }} <small class="text-muted">{{ data.title }}</small></h3>
        <div class="text-muted my-1">擅长：{{ data.good_at }}</div>
      </div>
      <span class="text-muted">></span>
    </div>
  </section>
</template>

<script>
import { apiURL } from '@/libs/const';

export default {
  name: 'DoctorListItem',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    avatar() {
      const { id } = this.data;
      return `${apiURL}/cloud-film-api/webapi/professional/get-doctor-avatar/${id}`;
    },
    routerLink() {
      const { id } = this.data;
      return {
        name: 'doctor-detail',
        params: {
          id,
        },
      };
    },
  },
};
</script>

<style scoped>
.doctor-item {
  background-color: #fff;
}

.doctor-item::after {
  content: ' ';
  background-color: #c0c0c0;
  margin-left: 1rem;
  height: 1px;
  display: block;
}

.doctor-item:last-child::after {
  margin-left: 0;
}

.doctor-item__avatar {
  width: 48px;
  height: 48px;
}

.doctor-item__content {
  flex: 1;
  max-width: calc(100% - 64px);
}
</style>
